import React, { Component } from 'react';
import ProjectForm from './ProjectForm';
import CardPage from '../../../commonModules/layouts/CardPage';
import { isEmpty } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PaygPopupInfo from '../paygPopupInfo';
import regexp from "node-regexp"
import Notif from '../../../commonModules/interface/Notif';
import { TableRow, TableCell, Button, TextField, Table, TableHead, TableBody } from '@material-ui/core';

const classState = {
    "OK": "success",
    "PaygBlocked": "danger",
    "NoConnection": "warning",
    "InitPAYG": "info",
    'Dispossess': "danger",
    'Demo': "warning",
    "FullyPaid": "success",
    "PaymentLate": "warning",
}

class ProjectList extends Component {
    state = { 
        openForm: false,
        popupUserInfo: false,
        client: {},
        userList: Object.values(this.props.CLIENTS),
        WAITING: {},
        FUNDING: {},
        FUNDED: {},
        header: "WAITING",
        CL_account: {
            email: "",
            ID: "",
        },
        notif:{
            show: false,
            message: "",
            title: "",
            type: "",
        },
    }
    componentDidMount() {
        this.getRefEmail()
        this.getUserList()
    }
    getRefEmail = async () => {
        let req = await fetch("/crowdlending/email/ref",{
            method:"GET",
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            credentials: 'same-origin',
        })
        let res = await req.json()
        console.log("getRefEmail", {res});

        if(!isEmpty(res.data)){
            let ID = await this.getRefID(res.data.email)
            if (ID === ""){
                console.log("getRefEmail DATA is empty ", res.data);
                return
            }
            this.setState({
                CL_account: {
                    email: res.data.email,
                    ID,
                },
            })    
        } else {
            console.log("getRefEmail is empty ", res.data);
        }

        // ******** DEV ***************
        // let dev_email = "kaniba.keita@myjoulebox.com"
        // let ID = await this.getRefID(dev_email)
        // this.setState({
        //     CL_account: {
        //         email: dev_email,
        //         ID,
        //     },
        // })   
        // ******** DEV ***************
        
    }

    getRefID = async (email) => {
        
        let req = await fetch("/crowdlending/ID/ref",{
            method:"POST",
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            body: JSON.stringify({email}),
            credentials: 'same-origin',
        })
        let res = await req.json()
        console.log("getRefID", {res});
        if(!isEmpty(res.data)){
            return res.data
        }
        return ""
    }

    getUserList = async (header = this.state.header) => {
        console.log('========getUserList=====================');
        console.log({header});
        console.log('====================================');
        if (isEmpty(this.state[header])){

            let req = await fetch("/crowdlending/get/user/list",{
                method:"POST",
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({type: header}),
                credentials: 'same-origin',
            })

            let res = await req.json()

            console.log("getUserList", {res});
            if(!isEmpty(res.data)){
                let list = {}
                let names = res.data.name
                let infos = res.data.info

                infos.forEach( user => {
                    let info = {}
                    user.forEach( (value, index) => {
                        info[names[index]] = value
                    })
                    list[info.idBox] = info
                }) 
                this.setState({[header]: list})
            } else {
                console.log("getUserList, No data , ",{res} )
            }
        }
    }
    openPopUpInfo = (client) => {
        console.log('=== OPEN POPUP =====================');
        console.log({client});
        console.log('====================================');
        this.setState({
            client,
            popupUserInfo: true, 
        })
    }
    handleTab = () => {

    }
    handleClose = () => {
        this.setState({
            popupUserInfo: false, 
            client: {},
        })
    }
    displayList = () => {
        const { SUBSCRIPTIONS, CLIENTS } = this.props;  
        let userList = this.state[this.state.header] 
        if ( isEmpty(CLIENTS) || isEmpty(SUBSCRIPTIONS) ) {
            return []
        }
        let list = Object.keys(userList).map( ID => {
            
            // let client = item.resume
            if ( !isEmpty(CLIENTS[ID]) ){
                
                let client = CLIENTS[ID].resume
                return (
                    <TableRow className={classState[client.systemStatus]}>
                        <TableCell onClick={() => this.openPopUpInfo(client)}>
                            {SUBSCRIPTIONS[client.subscriptionID].name}
                        </TableCell>
                        <TableCell onClick={() => this.openPopUpInfo(client)}>
                            {client.clientName}
                        </TableCell>
                        <TableCell onClick={() => this.openPopUpInfo(client)}>
                            {
                                new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(client.totalToPay) 
                            }
                        </TableCell>
                        <TableCell onClick={() => this.openPopUpInfo(client)}>
                            {client.systemStatus}
                        </TableCell>
                        <TableCell>
                            {this.state.header === "WAITING" &&
                                <Button 
                                    variant="contained"
                                    color="secondary"
                                    className="btn btn-warning" 
                                    onClick={
                                        () => this.setState({client:client, openForm: true})
                                    }
                                >Financer</Button>
                            }
                        </TableCell>
                    </TableRow>
                )
            } else {
                console.log('====================================');
                console.log("USER NOT FOUND : ", ID, userList[ID]);
                console.log('====================================');
            }
        })
        return list
    }
    handleSearch = (e) =>{
        const { CLIENTS, SUBSCRIPTIONS } = this.props;
        var match = e.target.value;
        var re = regexp().must(match).ignoreCase().toRegExp()
        var list = [];
        !isEmpty(CLIENTS) && Object.values(CLIENTS).forEach(user => {
          if (re.test(user.resume.clientName) || re.test(user.resume.idBox) || re.test(SUBSCRIPTIONS[user.resume.subscriptionID].name) ){
            list.push(user);
          }
        });
        this.setState({userList: list});
    }
    updateList = (data) => {
        let listSrc = Object.assign({}, this.state.WAITING)
        let list = Object.assign({}, this.state[data.status])
        delete listSrc[data.paygoID]
        list[data.paygoID] = {
            idBox: data.paygoID,
            statusFinancing: data.status,
            projectID: data.projectID
        }
        this.setState({
            WAITING: listSrc,
            [data.status]: list,
        })
    }
    notif = (show = false, type = "", message = "", title = "" ) => {
        this.setState({
            notif:{
                show,
                type,
                message,
                title,
            }
        })
    }
    render() {
        const { openForm, client } = this.state;
        const { show, message, title, type } = this.state.notif;

        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <div>          
                <Notif 
                    show={show}
                    message={message}
                    type={type}
                    title={title}
                    close={this.notif}
                />      
                {(!isEmpty(client) && openForm) && 
                    <ProjectForm 
                        handleClose={this.handleClose}
                        updateList={this.updateList}
                        client={client}
                        refID={this.state.CL_account.ID}
                        notif={this.props.notif}
                    /> 
                }
                {(this.state.popupUserInfo && !isEmpty(client)) &&
                    <PaygPopupInfo 
                        paygoID={client.idBox}
                        closePopup={()=>this.setState({ popupUserInfo:false, client:{} })}
                        USER_INFO_LIST = {["USER", "FAMILY", "OTHER"]}
                        // BOX_INFO_LIST = {["INSTALL", "BOX", "SYSTEM", "EQUIPEMENT","EQUIPEMENT_FROM_STORE_HOUSE"]}
                        PAYMENTS_INFO_LIST = {["RESUME", "LIST"]} 
                        home 
                        default_tab = {"INFO"}
                    />
                }
                <CardPage
                    title="Projets à financer"
                    subtitle="Liste des projets"
                >
                {!isEmpty(this.state.CL_account.email) && !isEmpty(this.props.CLIENTS) && 
                    <section>
                        <h3>{this.state.CL_account.email}</h3>
                        <div>
                            <ul className="tab-nav text-center">
                                <li className={this.state.header === "WAITING" ? "active" : ""}>
                                    <a href="#waiting" data-toggle="tab" onClick={() => {
                                        this.setState({ header: "WAITING" });
                                        this.getUserList("WAITING")
                                    } }>En Attente</a>
                                </li>
                                <li className={this.state.header === "FUNDING" ? "active" : ""}>
                                    <a href="#waiting" data-toggle="tab" onClick={() => {
                                        this.setState({ header: "FUNDING" });
                                        this.getUserList("FUNDING")
                                    } }>En Cours de Financement</a>
                                </li>
                                <li className={this.state.header === "FUNDED" ? "active" : ""}>
                                    <a href="#waiting" data-toggle="tab" onClick={() => {
                                        this.setState({ header: "FUNDED" });
                                        this.getUserList("FUNDED")
                                    } }>Financé</a>
                                </li>
                                
                            </ul>
                        </div>
                        <div>
                            <TextField
                                style={{width:"100%"}}
                                onChange={this.handleSearch}
                                variant="outlined"  
                                label="Rechercher" 
                                // margin="normal"
                                // value={this.props.search} 
                            />
                                
                            {/* <input type="text" className="custom-search" placeholder="Rechercher" onChange={this.handleSearch} 
                            /> */}
                        </div>
                    
                        <div className="table-responsive">
                            <Table className="table dataTable clickableRow">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Abonnement</TableCell>
                                        <TableCell style={{maxWidth: "150px"}}>Nom Client</TableCell>
                                        <TableCell>Total à Payer</TableCell>
                                        <TableCell>Etat Système</TableCell>
                                        <TableCell>Options</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.displayList()}
                                </TableBody>
                            </Table>
                        </div>

                    </section>
                }
                
                {isEmpty(this.state.CL_account.email) && 
                <div>
                    <p>Aucun compte MySolarLending connecté</p>
                    <p>Allez dans l'onglet <b>Configuration</b> <b>Financement</b> pour configurer le compte</p>
                </div>
                }
                </CardPage>
            </div>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        CLIENTS: state.clients,
        SUBSCRIPTIONS: state.subscriptions,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        // getClients: getPaygClients,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectList);